import './config';
import * as globalFunction from './GlobalFunction';

//自定义函数, 根据不同的类型去到不同的比较分支
export function compareUIElementValue(a, b, type) {
    switch (type) {
        case 'money':
        case 'positiveInteger':
            return compareNumerical(a, b);
        case 'date':
        case 'dateTime':
            return compareDateTime(a, b);
        case 'bool':
            return compareBool(a, b);
        default:
            return compareString(a, b);
    }
}

//比较各种类型, a>b 返回大于0的数值, a=b 返回 0, a<b 返回 返回小于0的数值
export function compareString(a, b) {
    return a.localeCompare(b);
}

export function compareLength(a, b) {
    return a.length - b.length;
}

export function compareNumerical(a, b) {
    return a - b;
}

export function compareBool(a, b) {
    if (a && !b) return 1;
    if (!a && b) return -1;
    return 0;
}

export function compareDateTime(a, b) {
    return globalFunction.stringToDateTime(a) - globalFunction.stringToDateTime(b);
}
